module.exports = __webpack_public_path__ + "static/media/open-menu-symbolic.ea2645ae.svg";